import { render, staticRenderFns } from "./WorkspaceList.vue?vue&type=template&id=553ca210&"
import script from "./WorkspaceList.vue?vue&type=script&lang=ts&"
export * from "./WorkspaceList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports